import { format } from 'date-fns';

export function formatCents(cents: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
}

export function formatDate(d: Date | string | null | undefined, fmt = 'PP'): string {
  if (!d) return '';
  const date = d instanceof Date ? d : new Date(d);
  return Number.isNaN(date.getTime()) ? '' : format(date, fmt);
}

export function formatDateTime(d: Date | string | null | undefined): string {
  return formatDate(d, 'PPp');
}
